(() => {
  const element = document.getElementById('BGWholesaleCheckoutConfig');
  if (!element || window.bgWholesaleCheckoutReady) return;
  window.bgWholesaleCheckoutReady = true;
  const config = JSON.parse(element.textContent);
  const format = new Intl.NumberFormat(document.documentElement.lang || 'en-AU', { style: 'currency', currency: config.currency });
  const allowedForms = new WeakSet();
  let checking = false;
  const showMessage = (message) => {
    const target = document.querySelector('[data-bg-minimum-message]') || document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
    if (target) {
      target.textContent = message;
      target.setAttribute('tabindex', '-1');
      target.focus();
      target.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    } else {
      window.alert(message);
    }
  };
  const verify = async () => {
    if (!config.approved) {
      window.location.assign(config.accessUrl);
      return false;
    }
    const response = await fetch(config.cartUrl, { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Cart unavailable');
    const cart = await response.json();
    if (!Number.isSafeInteger(cart.total_price) || cart.total_price < 0 || !Number.isSafeInteger(cart.item_count)) throw new Error('Invalid cart');
    const ready = cart.item_count > 0 && cart.total_price >= config.minimum;
    document.querySelectorAll('[data-bg-checkout]').forEach(button => { button.disabled = !ready; });
    if (!ready) showMessage(config.shortfall.replace('__amount__', format.format(Math.max(0, config.minimum - cart.total_price) / 100)));
    return ready;
  };
  document.addEventListener('submit', async event => {
    const form = event.target;
    const button = event.submitter;
    if (allowedForms.has(form)) { allowedForms.delete(form); return; }
    if (button?.name !== 'checkout') return;
    event.preventDefault();
    if (checking) return;
    checking = true;
    try {
      if (await verify()) {
        allowedForms.add(form);
        try { form.requestSubmit(button); } finally { allowedForms.delete(form); }
      }
    } catch {
      showMessage(config.error);
    } finally {
      checking = false;
    }
  }, true);
  document.addEventListener('click', async event => {
    const link = event.target.closest('a[href]');
    if (!link) return;
    const url = new URL(link.href, window.location.origin);
    if (url.origin !== window.location.origin || !/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?checkout(?:\/|$)/i.test(url.pathname)) return;
    event.preventDefault();
    if (checking) return;
    checking = true;
    try { if (await verify()) window.location.assign(url.href); }
    catch { showMessage(config.error); }
    finally { checking = false; }
  }, true);
})();
